import React from 'react';
import { MainProduct } from '../MainProduct';
import { ComplementaryProductsList } from '../ComplementaryProductsList';
import { Container, ProductsBox } from './styles';

export const ProductsList = () => (
  <Container>
    <ProductsBox>
      <MainProduct />
      <ComplementaryProductsList />
    </ProductsBox>
  </Container>
);
